import React, { useState } from 'react';
import {
  useFieldArray,
  UseFieldArrayReturn,
  useFormContext,
} from 'react-hook-form';
import EditableField from '../EditableField';
import ConfirmationDialog from '../ConfirmationDialog';
import * as styles from '../../DataExtractionTemplate.module.scss';
import { DataExtractionTemplateState } from '../../DataExtractionTemplate';
import {
  NO_EQUIVALENT_VALUE,
  validate,
} from 'pages/DataExtraction/components/editableFieldValidation';
import { Icon, IconList, Link } from 'components/core';
import { ReorderItem, ReorderItems } from 'components/core/Reorder';

type Props = {
  hasExtractedData: boolean;
  fullWidth?: boolean;
};

const InterventionsFields = ({ hasExtractedData, fullWidth }: Props) => {
  const [modal, setModal] = useState<React.ReactElement | null>();
  const { getValues } = useFormContext();
  const MAX_LENGTH = 255;

  const interventions = useFieldArray<DataExtractionTemplateState>({
    name: 'interventions.interventions',
  }) as UseFieldArrayReturn<
    DataExtractionTemplateState,
    `interventions.interventions`
  >;

  const handleAppend = async () => {
    interventions.append({
      name: '',
    });
  };

  const handleRemove = (index: number) => {
    interventions.remove(index);
  };

  return (
    <div>
      {modal}
      <ReorderItems
        items={interventions.fields}
        onMove={interventions.move}
        orderKey="id"
      >
        {interventions.fields?.map((field, index) => {
          return (
            <ReorderItem key={`${field.name}.${index}`} id={field.id}>
              <EditableField
                key={field.id}
                index={index}
                fullWidth={fullWidth}
                name="interventions.interventions"
                label="Intervention"
                onDelete={() => {
                  const { id } = getValues(
                    `interventions.interventions.${index}`
                  );

                  if (id && hasExtractedData) {
                    setModal(
                      <ConfirmationDialog
                        onConfirm={() => handleRemove(index)}
                        onClose={() => setModal(null)}
                      />
                    );
                  } else {
                    handleRemove(index);
                  }
                }}
                validate={(value, existingFields) => {
                  return validate(
                    value,
                    existingFields,
                    [],
                    NO_EQUIVALENT_VALUE,
                    MAX_LENGTH
                  );
                }}
              />
            </ReorderItem>
          );
        })}
      </ReorderItems>

      <Link
        onClick={handleAppend}
        variant="primary"
        className={styles.AddButton}
      >
        <Icon icon={IconList.light.faPlus} /> Add intervention
      </Link>
    </div>
  );
};

export default InterventionsFields;
